import React, { useState } from "react";
import { Flex, Input, Text } from "@paguelofacil/pf-components";

import "../../assets/scss/inputs.scss";

export const InputText = ({ name, id, label, placeholder, disabled, onChangeValue, validation, isRequired }) => {
    const [value, setValue] = useState(null);
    const [error, setError] = useState(null);

    const onChange = valueInput => {
        const errorForValidation = validation(valueInput);

        if (errorForValidation) {
            setError(errorForValidation);
            onChangeValue(null);
        } else {
            setError(null);
            onChangeValue(valueInput);
        }

        if (!valueInput) {
            setError("Campo requerido");
        }
        setValue(valueInput);
    };

    return (
        <Flex direction="column" align="stretch" gap="0.25rem">
            <Input
                className="inputs"
                labelClassName="input-label"
                variant="text"
                onChange={onChange}
                value={value}
                placeholder={placeholder}
                isDisabled={disabled}
                name={name}
                isRequired={isRequired}
                // onBlur={onBlur}
                label={
                    label
                    // <span className="title-info-payment-2">
                    //     {label}
                    //     <span style={{ color: "red" }}>&nbsp;*</span>
                    // </span>
                }
                id={id}
                showHint={error}
                hint={
                    error ? (
                        <Text variant="caption" weight="regular" color="red">
                            {error}
                        </Text>
                    ) : (
                        <></>
                    )
                }
            />
        </Flex>
    );
};
